import { CCourseTypes } from "./CCourseTypes";
export const CCourseTypesOptions = {
  [CCourseTypes.CLASS]: "Class",
  [CCourseTypes.COURSE]: "Course",
  [CCourseTypes.WORKSHOP]: "Workshop"
};
